export default {
  filter: {
    id: 'landing_page_filter',
    defaultMessage: 'Filter',
  },
  allFilters: {
    id: 'landing_page_all_filters',
    defaultMessage: 'All Filters',
  },
  sort: {
    id: 'landing_page_sort',
    defaultMessage: 'Sort',
  },
}
